import store from '../store/store.js'


const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('@/components/index'),
            children: [
                {path: '/', redirect: "main"},
                {
                    path: 'main',
                    component: () => import('@/components/main/mainIndex'),
                    children:[
                        {path: '/', name: 'Main', component: () => import('@/components/main/mainPage')},
                        {path: 'page/:code/:child?', name: 'Page', component: () => import('@/components/page/page')},
                        {path: 'search', name: 'Search', component: () => import('@/components/search/search')},
                        {path: 'searchDetail', name: 'SearchDetail', component: () => import('@/components/search/detail')},
                        {path: 'article/:code/:child?', name: 'ArticleList', component: () => import('@/components/list/articleList')},
                        {path: 'articleDetail/:code/:child?', name: 'ArticleDetail', component: () => import('@/components/list/articleDetail')},
                        {path: 'departments/:code/:child?/:child2?/:child3?', name: 'DepartmentsList', component: () => import('@/components/list/departmentsList')},
                        {path: 'departmentsDetail/:code/:child?', name: 'DepartmentsDetail', component: () => import('@/components/list/departmentsDetail')},
                        {path: 'images/:code/:child?/:child2?/:child3?', name: 'ImagesList', component: () => import('@/components/list/imagesList')},
                        {path: 'imagesDetail/:code/:child?', name: 'ImagesDetail', component: () => import('@/components/list/imagesDetail')},
                        {path: 'column/:code', name: 'Column', component: () => import('@/components/list/column')},
                    ]
                },
                {
                    path: 'dj',
                    component: () => import('@/components/main/djIndex'),
                    children:[
                        {path: '/', name: 'DjMain', component: () => import('@/components/main/djMain')},
                        {path: 'page/:code/:child?', name: 'DjPage', component: () => import('@/components/page/page')},
                        {path: 'search', name: 'DjSearch', component: () => import('@/components/search/search')},
                        {path: 'searchDetail', name: 'DjSearchDetail', component: () => import('@/components/search/detail')},
                        {path: 'article/:code/:child?', name: 'DjArticleList', component: () => import('@/components/list/articleList')},
                        {path: 'articleDetail/:code/:child?', name: 'DjArticleDetail', component: () => import('@/components/list/articleDetail')},
                        {path: 'departments/:code/:child?', name: 'DjDepartmentsList', component: () => import('@/components/list/departmentsList')},
                        {path: 'departmentsDetail/:code/:child?', name: 'DjDepartmentsDetail', component: () => import('@/components/list/departmentsDetail')},
                        {path: 'images/:code/:child?', name: 'DjImagesList', component: () => import('@/components/list/imagesList')},
                        {path: 'imagesDetail/:code/:child?', name: 'DjImagesDetail', component: () => import('@/components/list/imagesDetail')},
                        {path: 'column/:code', name: 'Column', component: () => import('@/components/list/column')},
                    ]
                },
                
            ]
        },
        {path: '/pageOutside/:code', name: 'PageOutside', component: () => import('@/components/page/outside')},
        {path: '/pageOutside/:code', name: 'DjPageOutside', component: () => import('@/components/page/outside')},
        {
            path: "*",
            redirect: "/"
        }
    ]
})

router.beforeEach((to, from, next) => {
    store.commit('updateLoadingStatus', {
        isLoading: true
    })
    window.scrollTo(0,0)  
    next()
})

router.afterEach(function (to) {
    store.commit('updateLoadingStatus', {
        isLoading: false
    })
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js